<template>
  <footer class="otc-footer">
    <div class="container">
      <div class="otc-footer-grid">
        <div class="otc-footer-brand">
          <a href="/" class="otc-footer-brand-link" aria-label="Off The Couch home">
            <img
              src="/img/otc-logo-white.png"
              alt="Off The Couch"
              class="otc-footer-logo"
              width="40"
              height="40"
              loading="lazy"
            />
            <span>Off The Couch</span>
          </a>
          <p class="otc-footer-tagline">
            The Venue Engine for booked experiences.
          </p>
        </div>

        <div class="otc-footer-col">
          <h5>Product</h5>
          <ul>
            <li><a href="/features">Features</a></li>
            <li><a href="/pricing">Pricing</a></li>
            <li><a href="/updates">Product updates</a></li>
            <!-- <li><a href="/blog">Blog</a></li> hidden until the blog ships -->
            <li><a href="https://docs.offthecouch.io/" target="_blank" rel="noopener">Documentation</a></li>
            <li><a href="https://status.offthecouch.io/" target="_blank" rel="noopener">System status</a></li>
          </ul>
        </div>

        <div class="otc-footer-col">
          <h5>Company</h5>
          <ul>
            <li><a href="/about">About</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="https://discord.gg/752E9HM6tt" target="_blank" rel="noopener">Discord community</a></li>
          </ul>
        </div>

        <div class="otc-footer-col">
          <h5>Legal</h5>
          <ul>
            <li><a href="/legal/privacy-policy" target="_blank" rel="noopener">Privacy policy</a></li>
            <li><a href="/legal/terms-of-service" target="_blank" rel="noopener">Terms of service</a></li>
            <li><a href="/legal/player-portal-terms" target="_blank" rel="noopener">Player portal terms</a></li>
          </ul>
        </div>
      </div>

      <div class="otc-footer-bottom">
        <span>&copy; {{ year }} Off The Couch</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/marketing-tokens';
// Footer uses slightly tighter muted scale than the rest of the site
$footer-muted: rgba(255, 255, 255, 0.55);
$footer-muted-2: rgba(255, 255, 255, 0.4);

.otc-footer {
  margin-top: 6rem;
  padding: 3.5rem 0 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(0, 0, 0, 0.2);
}

.otc-footer-grid {
  display: grid;
  grid-template-columns: 2fr repeat(3, 1fr);
  gap: 2.5rem;
  margin-bottom: 2.5rem;

  @media (max-width: 768px) { grid-template-columns: 1fr 1fr; gap: 2rem; }
  @media (max-width: 480px) { grid-template-columns: 1fr; gap: 1.75rem; }
}

.otc-footer-brand-link {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  text-decoration: none;
  color: white;
  font-weight: 800;
  font-size: 1.05rem;
  margin-bottom: 0.75rem;
  &:hover { color: white; text-decoration: none; }
}

.otc-footer-logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.otc-footer-tagline {
  color: $footer-muted;
  font-size: 0.88rem;
  line-height: 1.55;
  max-width: 320px;
  margin: 0;
}

.otc-footer-col {
  h5 {
    color: white;
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    margin-bottom: 1rem;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  li { padding: 0.3rem 0; }
  a {
    color: $footer-muted;
    font-size: 0.9rem;
    text-decoration: none;
    transition: color 0.15s ease;
    &:hover { color: $primary; text-decoration: none; }
  }
}

.otc-footer-bottom {
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  color: $footer-muted-2;
  font-size: 0.8rem;
}
</style>
